<!-- eslint-disable -->
<script setup>
import { useI18n } from 'vue-i18n';
import { useRegisterStore } from '../../stores/register';
import { onMounted, ref, watch } from 'vue';

const { t } = useI18n();
const registerStore = useRegisterStore();

const referralCode = ref(null);

const getCookieValue = (name) => {
	let cookie_array = document.cookie.split(';');
	for (let i = 0; i < cookie_array.length; i++) {
		let cookie_pair = cookie_array[i].split('=');
		if (name == cookie_pair[0].trim()) {
			return decodeURIComponent(cookie_pair[1]);
		}
	}
	return null;
};

const isReadOnly = ref(false);

onMounted(() => {
	const cookieCode = getCookieValue('referral_code');
	if (cookieCode) {
		referralCode.value = cookieCode;
		isReadOnly.value = true;
	}
});

// Sync with register store
watch(() => registerStore.register_input_fields.refer_friend_code, (newValue) => {
	if (newValue !== referralCode.value) {
		referralCode.value = newValue;
	}
}, { immediate: true });

watch(referralCode, (newValue) => {
	registerStore.register_input_fields.refer_friend_code = newValue;
});

</script>

<template>
	<div class="register-form-field">
		<label>{{ $t('account.register.refer_a_friend_code') }}</label>
		<input
			@keyup="registerStore.validateReferAFriendCode"
			class="form-input"
			:class="{'disabled-input': isReadOnly}"
			:placeholder="$t('account.register.refer_a_friend_code')"
			v-model="referralCode"
			type="text"
			name="refer_friend_code"
			:readonly="isReadOnly"
		/>
		<div class="register-form-list" v-if="registerStore.register_errors.refer_a_friend_code.error">
			<div class="password-meter">
				<div class="password-meter-bar">
					<div class="password-meter-bar-inn"></div>
				</div>
			</div>
			<p>
				<img src="@/assets/svgs/cross.svg" alt=""/>
				&nbsp;
				<!-- <span v-if="registerStore.register_errors.refer_a_friend_code.error === 'refer_a_friend_code_format'">
					{{ $t('account.register.error_refer_a_friend_code_format') }}
				</span>
				<span v-else-if="registerStore.register_errors.refer_a_friend_code.error === 'refer_a_friend_code_required'">
					{{ $t('account.register.error_refer_a_friend_code_required') }}
				</span> -->
				<span if="registerStore.register_errors.hasOwnProperty('refer_a_friend_code')">
					{{ registerStore.register_errors.refer_a_friend_code.error }}
				</span>
			</p>
		</div>
	</div>
</template>

<style scoped>
.register-form-main .register-outer-form .register-inner-form .password-meter .password-meter-bar {
	background-color:var(--red);
	margin-bottom:5px;
}
.register-form-main .register-form-list {
	margin-top:unset;
	padding-top:5px;
}
html[dir="rtl"] .register-form-main .register-outer-form .register-inner-form .form-input {
	padding: 10px 15px 10px 15px;
}
.disabled-input {
	background-color: var(--black-800);
	opacity: 0.7;
	cursor: not-allowed;
}
</style>
